export default class Palette {

    static TELIN_PINK = "#ff00f2"
    static TELIN_DARK_PINK = "#9e3e9e"

}
